
import commonPaths from "./commonPaths.js"

export default [ ...commonPaths ];